var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReverseFactoring = function SvgReverseFactoring(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M12 9h2c.6 0 1 .4 1 1h2c0-1.7-1.3-3-3-3V6h-2v1c-1.7 0-3 1.3-3 3s1.3 3 3 3h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1H9c0 1.7 1.3 3 3 3v1h2v-1c1.7 0 3-1.3 3-3s-1.3-3-3-3h-2c-.6 0-1-.4-1-1s.4-1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M12.9 2c3.5 0 6.6 1.7 8.4 4.6L18.9 9H25V3l-2.2 2.2C20.6 2 16.9 0 12.9 0 6.3 0 .9 5.4.9 12h2c0-5.5 4.5-10 10-10M13.1 22c-3.5 0-6.6-1.7-8.4-4.6L7.1 15H1v6l2.2-2.2C5.4 22 9.1 24 13.1 24c6.6 0 12-5.4 12-12h-2c0 5.5-4.5 10-10 10"
  })));
};
export default SvgReverseFactoring;